/**
 * Course progress analytics.
 */
import React, { useEffect, useMemo, useState } from "react";
import { Grid, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import BEmpty from "components/BEmpty";
import BProgressBar from "components/BProgressBar";
import { useAsterController } from "context";
import { VText } from "form";
import { mapSectionToGradeDetails } from "utils/grade.util";
import AnalysisCourseTotalProgress from "./analysis.course.total-progress";

/**
 * Shows overall and per-module progress for the current course.
 */
const AnalysisProgress = () => {

  const { t } = useTranslation('common');

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const currCourse = useMemo(() => (courses.data || []).find(v => v.id === courseId) || {}, [courses, courseId]);

  const [modules, setModules] = useState([]);

  useEffect(() => {
    const mapper = mapSectionToGradeDetails(currCourse).filter(m => m['details'] && m['cutoff'] !== 0);

    setModules(mapper.map((v, idx) => ({
      key: idx,
      title: v.sectionTitle,
      raw_earned: v.raw_earned,
      raw_possible: v.raw_possible,
      percent: v.raw_possible ? Math.round(v.raw_earned * 100 / v.raw_possible) : 0,
      success: v.raw_earned / v.raw_possible > v.cutoff
    })));

  }, [currCourse, currCourse.id]);


  return <>
    <Grid container className="md:mt-6 mt-2" id="v-report-2">
      <Grid item sm={12} className="flex">
        <VText className="text-2xl">{t("Progress")}</VText>
      </Grid>

      <Grid item xs={12} sm={5} className="mt-4">
        <AnalysisCourseTotalProgress />
      </Grid>

      <Grid item xs={12} sm={7}>
        {
          modules.length ?
            modules.map(module => <Box className="flex md:ml-12 sm:ml-4 mt-4 mb-10" key={module.key}>
              <Box className="flex items-center">
                <Box className="w-5 h-5 bg-red-600 rounded mr-2" />
                <VText>{module.raw_earned}/{module.raw_possible} {module.title}</VText>
              </Box>
              <BProgressBar
                className="w-32 text-xs ml-auto"
                label={module.title}
                value={module.percent}
                success={module.success}
              />
            </Box>)
            :
            <BEmpty />
        }
      </Grid>

    </Grid>
  </>;
};

export default AnalysisProgress;